<template lang="pug">
.shipment-item
  v-row
    v-col.d-flex.align-center
      h3.primaryHover--text Item {{ visibleIndex + 1 }}
  v-row
    v-col(cols="6")
      app-entity-display(
        :value="reducedInstance",
        :close="false",
        :edit="false",
        :columnsNumber="1"
        v-bind="{ entity }",
      )
    v-col(v-if="packageContent && packageContent.length > 0", cols="6")
      app-entity-display(
        :value="packageQuantities",
        :close="false",
        :edit="false",
        :columnsNumber="1"
        :keyFunction="false",
        customHeader="Package Quantities",
      )
</template>

<style lang="scss" scoped>
.package {
  ::v-deep i {
    color: var(--v-primary-base);
  }
}
</style>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: {
    extraData: {
      type: Boolean,
      default: true,
    },
    replasable: {
      type: Boolean,
      default: true,
    },
    chips: {
      type: Boolean,
      default: true,
    },
    invert: {
      type: Boolean,
      default: true,
    },
    selector: {
      type: Boolean,
      default: true,
    },
    selectorOnly: {
      type: Boolean,
      default: false,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    path: {
      type: String,
      default: null
    },
    parentPath: {
      type: String,
      default: null
    },
    fromList: Boolean,
    parent: {
      type: Object,
      default: () => ({})
    },
    parentInstance: {
      type: Object,
      default: () => ({})
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isAddEnabled: {
      type: Boolean,
      default: true
    },
    relation: null,
    elementIndex: null,
    visibleIndex: null,
    packageContent: null,
  },
  data: () => ({
    pickProduct: ['name', 'description', 'weight', 'weightUnit'],
    pickOrderLine: ['externalId', 'requestedQuantity', 'availableQuantity'],
  }),
  methods: { },
  computed: {
    errors() {
      return this.$store.state.errors;
    },
    isProduct() {
      return !_.get(this.instance, 'orderLineId');
    },
    entityName() {
      return this.isProduct ? 'Product' : 'OrderLine';
    },
    pickArray() {
      return this.isProduct ? this.pickProduct : this.pickOrderLine;
    },
    entity() {
      return this.$findEntity(this.entityName);
    },
    myInstance() {
      return _.get(this.instance, this.$lcfirst(this.entityName));
    },
    reducedInstance() {
      return _.pick(this.myInstance, this.pickArray);
    },
    myItemNo() {
      return _.get(this.instance, 'itemNo');
    },
    packageQuantities() {
      return _.reduce(this.packageContent, ({ shippingQuantity: oldSQ, ...rest }, { quantity, visibleIndex, package: { packaging, caseIdentifier } }) => {
        const key = `Package ${visibleIndex + 1} - ${packaging} ${caseIdentifier}`;
        const shippingQuantity = (oldSQ || 0) + quantity;
        return ({ ...rest, [key]: quantity, shippingQuantity });
      }, {});
    },
  }
}
</script>
